export function imperialWeight(weight) {
    return (Math.round((+weight) * 2.20462 * 100) / 100).toFixed(0);

}